export const QUERY_KEYS = {
  GLOBAL: {
    FETCH_ENUM: "GLOBAL_FETCH_ENUM",
    FETCH_PREFECTURE_AND_MUNICIPALITY_BY_ZIP_CODE: "FETCH_PREFECTURE_AND_MUNICIPALITY_BY_ZIP_CODE",
    FETCH_ADDRESS_CODES: "FETCH_ADDRESS_CODES",
  },
  FILE: {
    FETCH_INFO: "FILE_FETCH_INFO",
    FETCH_SIGNED_URL: "FILE_FETCH_SIGNED_URL",
  },
} as const;
